// Create Mock Data for Song from type Song in ./utils/types/index.ts


import {Song} from "../utils/types";
import song_art_1 from "../assets/data/song_art_1.png";


export const song: Song = {
    id: "1",
    uuid: "1",
    song_art_color: null,
    title: "The Box",
    album: "Fresh Fire",
    artist: "Roddy Ricch",
    artist_id: "1",
    writer: "Roddy Roy",
    song_art: song_art_1,
    album_art: song_art_1,
    file_url: '/audio.mp3',
    genre: "Hip-Hop",
    votes: 0,
    listens: 0,
    lyrics: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. ",
    solfa_notation_1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. ",
    rehearsals: 0,
    key: "C",
    tempo: "120",
    time_signature: "4/4",
    duration: "3:16",
    created_by: "jeandoe@email.com",
    tags: ["hip-hop", "rap", "gospel"],
    created_at: "2020-02-21T21:28:14.000Z",
    updated_at: "2020-02-21T21:28:14.000Z"
};

export const song_dump: Song[] = [
    {
        uuid: "1",
        album: "Fresh Fire",
        album_art: song_art_1,
        artist: "Roddy Ricch",
        artist_id: "3",
        created_at: "2020-02-21T21:28:14.000Z",
        created_by: "jeandoe@email.com",
        duration: "3:16",
        genre: "Hip-Hop",
        id: "1",
        key: "C",
        listens: 0,
        lyrics: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. ",
        solfa_notation_1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. ",
        rehearsals: 0,
        song_art: song_art_1,
        tags: ["hip-hop", "rap", "gospel"],
        tempo: "120",
        time_signature: "4/4",
        song_art_color: null,
        title: "The Box",
        updated_at: "2020-02-21T21:28:14.000Z",
        file_url: '/audio.mp3',
        votes: 0,
        writer: "Roddy Roy"
    },
    {
        uuid: "2",
        album: "Sound of Heaven",
        album_art: song_art_1,
        artist: "Femi Mathew",
        artist_id: "1",
        created_at: "2020-02-21T21:28:14.000Z",
        created_by: "jeandoe@email.com",
        duration: "3:16",
        genre: "Hip-Hop",
        id: "2",
        key: "C",
        listens: 0,
        lyrics: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. ",
        solfa_notation_1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. ",
        rehearsals: 0,
        song_art: song_art_1,
        tags: ["hip-hop", "rap", "gospel"],
        tempo: "120",
        time_signature: "4/4",
        song_art_color: null,
        title: "The Box",
        updated_at: "2020-02-21T21:28:14.000Z",
        file_url: 'https://elatech.sfo3.digitaloceanspaces.com/QmfWM4EKdufJdgGzdT7bmGWDaAfKvmWqVPydw1fAQtcXSY.mpga',
        votes: 0,
        writer: "Roddy Roy"
    },
    {
        uuid: "3",
        album: "Three R's",
        album_art: song_art_1,
        artist: "Videra",
        artist_id: "8",
        created_at: "2020-02-21T21:28:14.000Z",
        created_by: "jeandoe@email.com",
        duration: "3:16",
        genre: "Hip-Hop",
        id: "3",
        key: "C",
        listens: 0,
        lyrics: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. ",
        solfa_notation_1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. Donec euismod, nisl eget ultricies aliquam, nisl nisl aliquet nunc, vitae aliquam nisl nisl vitae nisl. ",
        rehearsals: 0,
        song_art: song_art_1,
        tags: ["hip-hop", "rap", "gospel"],
        tempo: "120",
        time_signature: "4/4",
        song_art_color: null,
        title: "The Box",
        updated_at: "2020-02-21T21:28:14.000Z",
        file_url: 'https://elatech.sfo3.digitaloceanspaces.com/QmWoH7Z7kZEEWHUw8J8SayKvQx2Kc9w8o1iRHmCkmcUfDd.mpga',
        votes: 0,
        writer: "Roddy Roy"
    },
]